import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button } from '@ipc/ipc-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Link,
} from '@ipc/ipc-core';
import {
  getData,
  getColumns,
  getSelectedImpcOnTable,
  getSelectedOperatorOnTable,
  getIsLoading,
  getCheckedRows,
} from '../redux/selectors/YearlyThresholdsSelectors';
import ListTable from '../../../common/tables/ListTable';
import TableDefinitions from '../../../common/TableDefinitions';
import {
  setSelectedOperatorImpcOnTable,
} from '../../../common/selection-criteria/operator-impc/redux/actions/OperatorImpcActions';
import { getUserRole } from '../../../common/user/redux/selectors/UserDataSelectors';
import DownloadTypes from '../../../common/tables/excel/DownloadTypes';
import { YearlyThresholdsContainerStyle } from './YearlyThresholdsContainer.styles';

class YearlyThresholdsContainer extends Component {
  constructor(props) {
    super(props);
    if (this.props.location.data !== undefined) {
      this.props.tableLoadData(this.props.location.state, this.props.appContext.appContext, { impcCode: this.props.location.data.original.impcCode });
      this.props.setSelectedOperatorImpcOnTable(this.props.location.data.original.operatorCode, this.props.location.data.original.impcCode);
    } else {
      this.props.tableLoadData(this.props.location.state, this.props.appContext.appContext, { impcCode: this.props.impc });
    }
  }

  generateAdditionalRowData = (row, index) => {
    const operatorCode = this.props.location.data ? this.props.location.data.original.operatorCode : this.props.operator;
    const impcCode = this.props.location.data ? this.props.location.data.original.impcCode : this.props.impc;

    return {
      operatorCode,
      impcCode,
    };
  }

  render() {
    return (
      <div className="general-content-container">
        <h1 className="title-div">BOH THRESHOLDS</h1>
        <div className="operator-info-div">
          <table className="operator-impc-detail">
            <tbody>
              <tr>
                <td className="selected-impc">Operator</td>
                <td className="selected-impc">{this.props.location.data !== undefined ? this.props.location.data.original.operatorCode : this.props.operator}</td>
              </tr>
              <tr>
                <td className="selected-impc">IMPC</td>
                <td className="selected-impc">{this.props.location.data !== undefined ? this.props.location.data.original.impcCode : this.props.impc}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {(this.props.userRole.includes('IPC_PALLET_BOX_MANAGER') || this.props.userRole.includes('IPC_TRAY_MANAGER') || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
          <div className="buttons-div">
            <Link to={{ pathname: 'weekly-thresholds-edit', state: { tableId: 'IMPC_DETAILS_PAGE' } }}>
              <Button
                className={`primary-button-${!(this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0)}`}
                disabled={!(this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0)}
              >
                EDIT MIN/MAX
              </Button>
            </Link>
          </div>
        )}
        <YearlyThresholdsContainerStyle>
          <div className="list-table-container">
            <ListTable
              listId={TableDefinitions.YEARLY_THRESHOLDS_PAGE.id}
              loading={this.props.isLoading}
              columns={this.props.columns}
              data={this.props.data}
              keyField="id"
              selectCheckbox
              pagination
              downloadType={DownloadTypes.EXCEL}
              downloadFileAs="BOH_THRESHOLDS"
              downloadAdditionalRowGenerator={this.generateAdditionalRowData}
            />
          </div>
        </YearlyThresholdsContainerStyle>
        <div className="buttons-div">
          <Link to={{ pathname: 'impc-details', state: { tableId: 'IMPC_DETAILS_PAGE' } }}>
            <Button className="primary-button-false">
              Back
            </Button>
          </Link>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    impc: getSelectedImpcOnTable(state),
    operator: getSelectedOperatorOnTable(state),
    checkedRows: getCheckedRows(state),
    userRole: getUserRole(state),
    isLoading: getIsLoading(state),
  };
}
const mapDispatchToProps = (dispatch) => bindActionCreators({
  setSelectedOperatorImpcOnTable,
}, dispatch);

YearlyThresholdsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  userRole: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  location: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.shape),
  setSelectedOperatorImpcOnTable: PropTypes.func,
  operatorCode: PropTypes.string,
  impcCode: PropTypes.string,
  impc: PropTypes.string,
  operator: PropTypes.string,
  checkedRows: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(YearlyThresholdsContainer);
